import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button, Message, Table } from 'semantic-ui-react';
import { SG_GET_STAFF_CACHE_STATUS } from 'constants/actions';

const CheckCacheStatusModal = ({ open, onClose, organizationId = null, auditTypeId = null }) => {
  const dispatch = useDispatch();
  const cacheStatus = useSelector((s) => s.staff_reports.cache_status);
  const pending = useSelector((s) => s.staff_reports.pending);

  const [org, setOrg] = useState(organizationId);
  const [audit, setAudit] = useState(auditTypeId);

  useEffect(() => {
    setOrg(organizationId);
    setAudit(auditTypeId);
  }, [organizationId, auditTypeId]);

  useEffect(() => {
    if (open && org && audit) {
      const q = `organization_id=${org}&audit_type_id=${audit}`;
      dispatch({ type: SG_GET_STAFF_CACHE_STATUS, payload: q });
    }
  }, [open, org, audit, dispatch]);

  return (
    <Modal open={open} onClose={onClose} size="small">
      <Modal.Header>Cache status — org: {org || 'n/a'} audit: {audit || 'n/a'}</Modal.Header>
      <Modal.Content>
        {pending ? (
          <Message info>Loading cache status…</Message>
        ) : cacheStatus ? (
          <div>
            {cacheStatus.message ? <Message info>{cacheStatus.message}</Message> : null}

            <Table basic='very' celled>
              <Table.Body>
                <Table.Row>
                  <Table.Cell><strong>Cached</strong></Table.Cell>
                  <Table.Cell>{String(!!cacheStatus.cached)}</Table.Cell>
                </Table.Row>
                {cacheStatus.active !== undefined && (
                  <Table.Row>
                    <Table.Cell><strong>Active</strong></Table.Cell>
                    <Table.Cell>{String(!!cacheStatus.active)}</Table.Cell>
                  </Table.Row>
                )}
                {cacheStatus.total_variants !== undefined && (
                  <Table.Row>
                    <Table.Cell><strong>Total variants</strong></Table.Cell>
                    <Table.Cell>{cacheStatus.total_variants}</Table.Cell>
                  </Table.Row>
                )}
                {cacheStatus.generated_at && (
                  <Table.Row>
                    <Table.Cell><strong>Generated</strong></Table.Cell>
                    <Table.Cell>{cacheStatus.generated_at}</Table.Cell>
                  </Table.Row>
                )}
                {cacheStatus.expires_at && (
                  <Table.Row>
                    <Table.Cell><strong>Expires</strong></Table.Cell>
                    <Table.Cell>{cacheStatus.expires_at}</Table.Cell>
                  </Table.Row>
                )}
                {cacheStatus.access_count !== undefined && (
                  <Table.Row>
                    <Table.Cell><strong>Access count</strong></Table.Cell>
                    <Table.Cell>{cacheStatus.access_count}</Table.Cell>
                  </Table.Row>
                )}
                {cacheStatus.last_accessed_at && (
                  <Table.Row>
                    <Table.Cell><strong>Last accessed</strong></Table.Cell>
                    <Table.Cell>{cacheStatus.last_accessed_at}</Table.Cell>
                  </Table.Row>
                )}
                {cacheStatus.task_id && (
                  <Table.Row>
                    <Table.Cell><strong>Task ID</strong></Table.Cell>
                    <Table.Cell>{cacheStatus.task_id}</Table.Cell>
                  </Table.Row>
                )}
                {cacheStatus.report_size_bytes !== undefined && (
                  <Table.Row>
                    <Table.Cell><strong>Report size (bytes)</strong></Table.Cell>
                    <Table.Cell>{cacheStatus.report_size_bytes}</Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>

            {cacheStatus.variants && cacheStatus.variants.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <strong>Cache keys ({cacheStatus.variants.length})</strong>
                <ul>
                  {cacheStatus.variants.slice(0, 20).map((v, i) => <li key={i}><code>{v}</code></li>)}
                </ul>
                {cacheStatus.variants.length > 20 && <em>Showing first 20 keys</em>}
              </div>
            )}
          </div>
        ) : (
          <Message warning>No data — set Organization and Audit type and click Refresh.</Message>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Close</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default CheckCacheStatusModal;
